export const seoSitemap: ISitemapTag[] = [
  //   { customUrl: '/contacts', title: 'Contacts - Quad Industry GmbH', description: 'Contacts - Quad Industry GmbH', image: null, keywords: null },
  // { customUrl: '/about', title: 'About - Quad Industry GmbH', description: 'About - Quad Industry GmbH',  image: null, keywords: null },  
  // { customUrl: '/', title: '111', description: '222', image: null, keywords: null }

];

export interface ISitemapTag {
  customUrl: string;
  title: string | null;
  description: string | null;
  image: string | null;
  keywords: string | null;
}